import React from "react";
import Style from "../styles/text.module.scss";
const TitleH1Component = (props) => {
    return (
        <h1 className={`${Style.h1} ${props.styleGroup}`}>{props.children}</h1>
    )
}
export default TitleH1Component;